import Icon from '../components/Icon.vue'

Icon.register({
  fish: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M327.1 96C237.1 96 158.6 150.8 114.8 197.6L27.5 131.6C15.4 122.4-2.7 132.2 0.4 146.2L24.5 256 0.3 365.8C-2.8 379.8 15.4 389.6 27.5 380.4L114.8 314.4C158.6 361.2 237.1 416 327.1 416 464.6 416 576 288 576 256S464.6 96 327.1 96zM414.5 280C401.3 280 390.5 269.3 390.5 256 390.5 242.7 401.3 232 414.5 232 427.8 232 438.5 242.7 438.5 256 438.5 269.3 427.8 280 414.5 280z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fish.js
// module id = y7Vh
// module chunks = 144